export default "__VITE_ASSET__DtTT6N4r__"